import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {NoticesService} from '../../services/notices.service';
import {UrlService} from '../../services/url.service';

@Component({
    templateUrl: 'notices.component.html',
})
export class NoticesComponent implements OnInit, OnDestroy {

    constructor(public noticesService: NoticesService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.noticesService.getBuildings();

        this.urlService.onUrlChange.subscribe(() => {
            this.noticesService.tabId = this.urlService.queryParams['tab'];
            this.noticesService.getData();
        });
        this.urlService.queryParams['status'] = 'received';
        this.urlService.setQueryParams('allNotices');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.noticesService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.noticesService.emptyRowService.fillEmptyRow();
    }

}





// WEBPACK FOOTER //
// /app/src/app/views/notices/notices.component.ts